import React from "react"
import {Address} from "../../dtos/orderResponse"
import FieldDisplay from "../formatting/FieldDisplay"

interface AddressProps {
	address: Address
}

export default function AddressDetails(props: AddressProps) {
	const {address} = props

	return (
		<div>
			{address && (
				<div>
					{/* // ToDo: fix up this UI */}
					{(address.firstName || address.lastName) && (
						<FieldDisplay label="Name" data={`${address.firstName} ${address.lastName}`} />
					)}
					{address.streetName && <FieldDisplay label="Street name" data={address.streetName} />}
					{address.additionalStreetInfo && (
						<FieldDisplay label="Street Info" data={address.additionalStreetInfo} />
					)}

					{address.city && <FieldDisplay label="City" data={address.city} />}
					{address.region && <FieldDisplay label="Region" data={address.region} />}
					{address.state && <FieldDisplay label="State" data={address.state} />}
					{address.postalCode && <FieldDisplay label="ZIP" data={address.postalCode} />}
					{address.country && <FieldDisplay label="Country" data={address.country} />}

					{address.email && <FieldDisplay label="Email" data={address.email} />}

					{address.phone && <FieldDisplay label="Phone" data={address.phone} />}
					{address?.metadata?.pickupPointName && (
						<FieldDisplay label="PickUp Point" data={address?.metadata?.pickupPointName} />
					)}
				</div>
			)}
		</div>
	)
}
